<template>
  <v-container class="limited">
    <v-layout column>
      <beneficiary-data></beneficiary-data>
      <v-card class="elevation-5 mb-4 px-5 py-3">
        <div>
          <h1 class="subheading font-weight-black primary--text mt-3">
            Relatório de dados da mensalidade
          </h1>
          <v-layout row wrap align-center justify-start
            ><h1
              class="subheading font-weight-black grey--text text--darken-2"
              :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
            >
              Filtrar período
            </h1>
            <v-flex xs12 sm3 md2>
              <v-menu
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filtroMensalidade.periodoDe"
                    label="De"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filtroMensalidade.periodoDe"
                  type="month"
                  min="1950-01-01"
                  locale="pt-br"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm3 md2>
              <v-menu
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filtroMensalidade.periodoAte"
                    label="Até"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filtroMensalidade.periodoAte"
                  type="month"
                  min="1950-01-01"
                  locale="pt-br"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="ma-3 white--text"
              dark
              :loading="loadingDownloadRelatorioMensalidade"
              :disabled="canDownloadMensalidadeReport"
              @click="downloadRelatorioMensalidade"
            >
              Baixar
              <v-icon right>cloud_download</v-icon>
            </v-btn>
          </v-layout>
        </div>
      </v-card>
      <v-card class="elevation-5 mb-4 px-5 py-3">
        <div>
          <h1 class="subheading font-weight-black primary--text mt-3">
            Relatório de valores e percentuais de desconto
          </h1>
          <v-layout row wrap align-center justify-start
            ><h1
              class="subheading font-weight-black grey--text text--darken-2"
              :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
            >
              Filtrar período
            </h1>
            <v-flex xs12 sm3 md2>
              <v-menu
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filtroValoresContrato.periodoDe"
                    label="De"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filtroValoresContrato.periodoDe"
                  type="month"
                  min="1950-01-01"
                  locale="pt-br"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm3 md2>
              <v-menu
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filtroValoresContrato.periodoAte"
                    label="Até"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filtroValoresContrato.periodoAte"
                  type="month"
                  min="1950-01-01"
                  locale="pt-br"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="ma-3 white--text"
              dark
              :disabled="canDownloadValoresContratoReport"
              :loading="loadingDownloadRelatorioValoresContrato"
              @click="downloadRelatorioValoresContrato"
            >
              Baixar
              <v-icon right>cloud_download</v-icon>
            </v-btn>
          </v-layout>
        </div>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import {
  buscaDadosValoresContrato,
  buscaDadosMensalidade
} from "@/services/reports";

import BeneficiaryData from "@/components/BeneficiaryData";

import { downloadCsv } from "@/utils/relatorio.js";

const beneficiarioStore = createNamespacedHelpers("beneficiario");
const portalStore = createNamespacedHelpers("portal");

export default {
  name: "Reports",
  components: {
    BeneficiaryData
  },
  data() {
    return {
      filtroMensalidade: {
        periodoDe: null,
        periodoAte: null
      },
      filtroValoresContrato: {
        periodoDe: null,
        periodoAte: null
      },
      loadingDownloadRelatorioMensalidade: false,
      loadingDownloadRelatorioValoresContrato: false
    };
  },
  computed: {
    ...beneficiarioStore.mapState(["dadosBeneficiario"]),
    ...portalStore.mapState(["highContrast"]),
    canDownloadMensalidadeReport() {
      return !(
        this.filtroMensalidade?.periodoDe && this.filtroMensalidade?.periodoAte
      );
    },
    canDownloadValoresContratoReport() {
      return !(
        this.filtroValoresContrato?.periodoDe &&
        this.filtroValoresContrato?.periodoAte
      );
    }
  },
  methods: {
    ...portalStore.mapMutations(["setErrorToast"]),
    downloadRelatorioMensalidade() {
      this.loadingDownloadRelatorioMensalidade = true;
      const contratoId = this.dadosBeneficiario?.contratoId;
      const { periodoDe, periodoAte } = this.filtroMensalidade;

      if (contratoId && periodoDe && periodoAte) {
        const formattedPeriodoDe = periodoDe.replace("-", "");
        const formattedPeriodoAte = periodoAte.replace("-", "");

        buscaDadosMensalidade(
          formattedPeriodoDe,
          formattedPeriodoAte,
          contratoId
        )
          .then(data => {
            if (data) downloadCsv(data, "RelatorioMensalidade.csv");
          })
          .catch(({ data }) => {
            if (!data) {
              this.$toast.warning(
                "Não foram encontrados dados para os filtros informados."
              );
            }
          })
          .finally(() => {
            this.loadingDownloadRelatorioMensalidade = false;
          });
      }
    },
    downloadRelatorioValoresContrato() {
      this.loadingDownloadRelatorioValoresContrato = true;
      const contratoId = this.dadosBeneficiario?.contratoId;
      const { periodoDe, periodoAte } = this.filtroValoresContrato;

      if (contratoId && periodoDe && periodoAte) {
        const formattedPeriodoDe = periodoDe.replace("-", "");
        const formattedPeriodoAte = periodoAte.replace("-", "");
        buscaDadosValoresContrato(
          formattedPeriodoDe,
          formattedPeriodoAte,
          contratoId
        )
          .then(data => {
            if (data) downloadCsv(data, "RelatorioValoresDesconto.csv");
          })
          .catch(({ data }) => {
            if (!data) {
              this.$toast.warning(
                "Não foram encontrados dados para os filtros informados."
              );
            }
          })
          .finally(() => {
            this.loadingDownloadRelatorioValoresContrato = false;
          });
      }
    }
  }
};
</script>
